import axios from "axios";

import { ENDPOINT } from "../../constant/environment";
import { iChatStreamingPayload } from "../../interface/common";
import { decryptData, encryptData, getHeaderConfig } from "../../utils/api/encryption";
import { consoleLog } from "../../utils/consoleLog/consoleLog";
import { hasUsableJWT } from "../../utils/authentication/hasUsableJWT";

export async function chatStreaming(accessJWT: string, payload: iChatStreamingPayload, signal: any) {
  const URL = `${ENDPOINT}/app/v1/itineraries/stream`;
  let config = getHeaderConfig(signal, accessJWT);
if (!hasUsableJWT(accessJWT, "chatStreaming")) return null;
  try {
    const response = await axios.post(URL, encryptData(payload), config);
    if (response?.data) {
      const decryptedData = decryptData(response?.data);
      consoleLog(["CHAT STREAM RESPONSE", JSON.parse(decryptedData)]);
      return decryptedData ? JSON.parse(decryptedData) : null;
    }
    return null;
  } catch (error: any) {
    consoleLog(["CHATSTREAM ERROR", error]);
    return null;
  }
}

export async function modifyItineraryStreaming(accessJWT: string, payload: iChatStreamingPayload, signal: any) {
  const URL = `${ENDPOINT}/app/v1/itineraries/stream`;
  let config = getHeaderConfig(signal, accessJWT);
if (!hasUsableJWT(accessJWT, "modifyItineraryStreaming")) return null;
  try {
    const response = await axios.post(URL, encryptData(payload), config);
    if (response?.data) {
      const decryptedData = decryptData(response?.data);
      return decryptedData ? JSON.parse(decryptedData) : null;
    }
    return null;
  } catch (error: any) {
    return null;
  }
}
